



















import { StaffType, type Staff } from '@/data';
import type { Image3DPageData, Image3DRowData } from '@/data/Source';
import type { PropType } from 'vue';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    pages: {
      required: true,
      type: Array as PropType<Image3DPageData[]>,
    },
    width: {
      default: 0,
      type: Number,
    },
    sourceType: {
      default: 'score',
      type: String,
    },
    renderStaves: {
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
      type: Boolean,
    },
    showLines: {
      type: Boolean,
    },
  },
  data() {
    return {
      PADDING_SHADE: 4,
    };
  },
  methods: {
    stavesToRender(row: Image3DRowData) {
      if (['3d', 'grid', 'tab'].includes(this.sourceType) || this.renderStaves) {
        return row.staves;
      }
      return row.staves.filter((s) => s.name === 'all');
    },
    staffHeight(staff: Staff) {
      if (['3d', 'grid', 'tab'].includes(this.sourceType) || this.renderStaves) {
        return staff.height - this.PADDING_SHADE;
      }
      return this.computeNoStavesRenderHeight();
    },
    staffClass(staff: Staff) {
      let ret = 'staff';
      if (['3d', 'grid', 'tab'].includes(this.sourceType) || this.renderStaves) {
        if (staff.name === 'all') ret += ' click-through';
        if (this.showLines && this.isLineStaff(staff)) ret += ' show-line';
      }
      return ret;
    },
    computeNoStavesRenderHeight(): number {
      const allStaffHeight = this.pages[0].rows[0].staves.find((s) => s.name === 'all')?.height || 0;
      const additionalStaffHeight = this.pages[0].rows[0].staves.find((s) => s.name === 'top.1')?.height || 0;
      return allStaffHeight - this.PADDING_SHADE - additionalStaffHeight * 6;
    },
    isLineStaff(staff: Staff): boolean {
      return staff.type === StaffType.line;
    },
  },
});

